import React from "react"
import PropTypes from "prop-types"
import * as styles from "./ListComponent-tw-styles"
import Link from "../Link/Link"

function ListComponent({ linksCollection, label, variant }) {
  const style = styles[variant] || styles.defaultStyle
  const { listmob, Listcontainer, listLink } = style
  return (
    <>
      {label && (
        <h3 className="list-component text-[12px] leading-[15px] md:leading-[30px] text-white uppercase font-MDLZBiteType md:text-[24px] text-center md:text-left tracking-[0.6px] lg:leading-[30px] lg:pr-[40px] lg:h-[60px] md:h-[90px] lg:mb-[40px]">
          {label}
        </h3>
      )}
      <ul className={`${listmob} `}>
        {linksCollection?.map((link, index) => (
          <li className={Listcontainer} key={index}>
            <Link {...link} className={listLink} />
          </li>
        ))}
      </ul>
    </>
  )
}

ListComponent.propTypes = {
  linksCollection: PropTypes.array,
  variant: PropTypes.string,
  label: PropTypes.string,
}

export default ListComponent
